var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#222c3c;}.cls-2{fill:none;}")),React.createElement("title",{"key":1},"Hide Menu"),React.createElement("path",{"className":"cls-1","d":"M14.1208,12l6.93945-6.93945a1.49984,1.49984,0,0,0-2.12109-2.12109L11.99971,9.87891,5.06025,2.93945A1.49984,1.49984,0,0,0,2.93916,5.06055L9.87861,12,2.93916,18.93945a1.49984,1.49984,0,1,0,2.12109,2.12109l6.93945-6.93945,6.93945,6.93945a1.49984,1.49984,0,1,0,2.12109-2.12109Z","key":2}),React.createElement("rect",{"className":"cls-2","width":"24","height":"24","key":3})]);
}

Close.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
